__turbopack_context__.v({
  "button": "index-module__rHmRJa__button",
  "neutral": "index-module__rHmRJa__neutral",
  "primary": "index-module__rHmRJa__primary",
  "secondary": "index-module__rHmRJa__secondary",
  "small": "index-module__rHmRJa__small",
  "special": "index-module__rHmRJa__special",
});
